import { FC } from "react";

import Slide from "@mui/material/Slide";
import useScrollTrigger from "@mui/material/useScrollTrigger";

import { IHideOnScrollProperties } from "./HideOnScroll.types";

const HideOnScroll: FC<IHideOnScrollProperties> = ({ children }) => {
  const isScrolledDown = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!isScrolledDown}>
      {children}
    </Slide>
  );
};

export default HideOnScroll;
